import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import LifecycleSettings from './LifecycleSettings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lifecycle'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'lifecycle_wrapper',
          meta: { permissions: ['administrator'] },
          redirect: to => ({ name: 'lifecycle_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'lifecycle_list',
          meta: {
            featureFlag: FEATURE_FLAGS.LIFECYCLE,
            permissions: ['administrator'],
          },
          component: LifecycleSettings,
        },
      ],
    },
  ],
};
